import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing, typography }) => ({
  container: {
    padding: spacing(1.5),
    overflowX: 'auto',
    overflowY: 'hidden',
    paddingLeft: 0,
  },
  chip: {
    fontSize: typography.pxToRem(11),
    backgroundColor: '#fff',
  },
}));
